import { isEmpty } from 'lodash'

import { TAppTypesDisplaySubsitutes } from 'types/apps'
import { TPermission } from 'types/permissions'

export const setCheckedPermission = (
  permissions: TPermission[],
  appName: TAppTypesDisplaySubsitutes,
  defaultCheck: boolean
) => {
  // check if there has been set permission
  const filterPermissionsByAppName = permissions?.filter(({ subject }) => subject === appName)

  if (!isEmpty(filterPermissionsByAppName)) {
    return true
  } else {
    return defaultCheck
  }
}
